document.addEventListener('turbolinks:load', function () {
  var $ = window.jQuery || window.$;

  var dailyForecastTable = document.getElementById('daily-forecast-table');
  if (dailyForecastTable) {
    var dailyTableObserver = new MutationObserver(function () {
      dailyForecastTable.style.height = '';
      dailyForecastTable.style.minHeight = '';
    });
    dailyTableObserver.observe(dailyForecastTable, {
      attributes: true,
      attributeFilter: ['style']
    });
  }

  var dailyForecastList = document.getElementById('daily-forecast-list');
  if (dailyForecastList) {
    var dailyListObserver = new MutationObserver(function () {
      dailyForecastList.style.height = '';
      dailyForecastList.style.minHeight = '';
    });
    dailyListObserver.observe(dailyForecastList, {
      attributes: true,
      attributeFilter: ['style']
    });
  }

  if (!$) {
    return;
  }

  $(document)
    .off('click.hourlyDetails', '.hourly-row-toggle')
    .on('click.hourlyDetails', '.hourly-row-toggle', function (event) {
      event.preventDefault();

      var $button = $(this);
      var targetSelector = $button.attr('data-hourly-target');
      if (!targetSelector) {
        return;
      }

      var $target = $(targetSelector);
      if (!$target.length) {
        return;
      }

      var shouldOpen = !$target.hasClass('show');
      $target.toggleClass('show', shouldOpen);
      $button.toggleClass('collapsed', !shouldOpen);
      $button.attr('aria-expanded', shouldOpen ? 'true' : 'false');
    });

  $(document)
    .off('click.hourlyMore', '.hourly-show-more')
    .on('click.hourlyMore', '.hourly-show-more', function (event) {
      event.preventDefault();

      var $button = $(this);
      var targetSelector = $button.attr('data-hourly-more-target');
      if (!targetSelector) {
        return;
      }

      var $target = $(targetSelector);
      if (!$target.length) {
        return;
      }

      var shouldOpen = !$target.hasClass('show');
      $target.toggleClass('show', shouldOpen);
      $button.toggleClass('is-open', shouldOpen);
      $button.attr('aria-expanded', shouldOpen ? 'true' : 'false');
    });
});
